export const Colors = {
  mainBackgroundColor: '#f5f2f2',
}